gsap.registerPlugin(
  ScrollTrigger
);
const emToPx = (em) => {
  return em * parseFloat(getComputedStyle(document.body).fontSize);
};

function isMobile() {
  return window.matchMedia("(max-width:767px)").matches;
}
function isTablet() {
  return window.matchMedia("(min-width:768px) and (max-width:991px)").matches;
}
function isDesktop() {
  return window.matchMedia("(min-width:992px)").matches;
}
function initLenis() {

  window.locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
      lerp: 0.1,
      duration: 0.6,
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      normalizeWheel: true,
      autoResize: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    },
  });

  // Reviews and other Shopify app blocks can grow after smooth scrolling starts.
  // Refresh Lenis's wheel limit as well as Locomotive's scroll measurements.
  let lastPageHeight = -1;
  let resizeQueued = false;
  function refreshScrollHeight() {
    if (resizeQueued) return;
    resizeQueued = true;
    requestAnimationFrame(() => {
      resizeQueued = false;
      const pageHeight = document.documentElement.scrollHeight;
      if (pageHeight === lastPageHeight) return;
      lastPageHeight = pageHeight;
      window.locomotiveScroll.lenisInstance?.resize();
      window.locomotiveScroll.resize();
    });
  }

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(refreshScrollHeight).observe(document.body);
  }
  window.addEventListener('load', refreshScrollHeight, { once: true });
  window.addEventListener('pageshow', refreshScrollHeight);
  refreshScrollHeight();

}
function siteBy() {
  if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    var args = ['%cMade with ♥ by Atlantiser®', 'color: #fff; background:rgb(0, 0, 0); padding:10px 10px;'];
    window.console.log.apply(console, args);
  } else if (window.console) {
    window.console.log('Made with love ♥ Atlantiser®');
  }
}
function noticeSlider() {
  let noticeSliderWrap = document.querySelector(".header-notice .swiper");
  if (!noticeSliderWrap || typeof Swiper === 'undefined') return;
  new Swiper(noticeSliderWrap, {
    slidesPerView: 1,
    rewind: true,
    pagination: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: noticeSliderWrap.querySelector('.swiper-button-next'),
      prevEl: noticeSliderWrap.querySelector('.swiper-button-prev'),
    },
  });
}
function userResultsSlider() {
  let userResultsSliderWrap = document.querySelector(".user-results__products");
  if (!userResultsSliderWrap) return;
  const currentEl = userResultsSliderWrap.querySelector('.current-slide');
  const totalEl = userResultsSliderWrap.querySelector('.total-slides');

  const swiper = new Swiper('.user-results__products .swiper', {
    slidesPerView: 2,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 10,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        if (currentEl) currentEl.textContent = this.activeIndex + 1;
        if (totalEl) totalEl.textContent = this.slides.length;
      },
      slideChange: function () {
        if (currentEl) currentEl.textContent = this.activeIndex + 1;
      }
    }
  });
}
function productsSlider() {
  let productsSliderWrap = document.querySelector(".products-swiper");
  if (!productsSliderWrap) return;
  const currentEl = productsSliderWrap.querySelector('.current-slide');
  const totalEl = productsSliderWrap.querySelector('.total-slides');

  const swiper = new Swiper('.products-swiper .swiper', {
    slidesPerView: 3,
    spaceBetween: 15,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      }
      ,
      992: {
        slidesPerView: 3,
        spaceBetween: emToPx(1.6),
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        if (currentEl) currentEl.textContent = this.activeIndex + 1;
        if (totalEl) totalEl.textContent = this.slides.length;
      },
      slideChange: function () {
        if (currentEl) currentEl.textContent = this.activeIndex + 1;
      }
    }
  });
}
function ingradientSlider() {
  let productsSliderWrap = document.querySelector(".features .swiper");
  if (!productsSliderWrap) return;
  const currentEl = productsSliderWrap.querySelector('.current-slide');
  const totalEl = productsSliderWrap.querySelector('.total-slides');
  let prevEl = productsSliderWrap.querySelector('.swiper-button-prev');
  let nextEl = productsSliderWrap.querySelector('.swiper-button-next');

  const swiper = new Swiper('.features .swiper', {
    slidesPerView: 2,
    spaceBetween: 15,
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: {
      init: function () {
        if (currentEl) currentEl.textContent = this.activeIndex + 1;
        if (totalEl) totalEl.textContent = this.slides.length;
      },
      slideChange: function () {
        if (currentEl) currentEl.textContent = this.activeIndex + 1;
      }
    }
  });
}
// function accordion() {
//   document.querySelectorAll('.accordion').forEach(accordionEl => {
//     const buttons = accordionEl.querySelectorAll('.accordion-button');
//     const items = accordionEl.querySelectorAll('.accordion-item');
//     if (buttons.length <= 0) return;

//     buttons.forEach(button => {
//       button.addEventListener('click', () => {
//         const isActive = button.classList.contains('active');

//         // Close all items in this accordion
//         buttons.forEach(btn => {
//           btn.classList.remove('active');
//           btn.setAttribute('aria-expanded', 'false');
//         });

//         // Open clicked item if it wasn't already open
//         if (!isActive) {
//           button.classList.add('active');
//           button.setAttribute('aria-expanded', 'true');
//         }
//       });
//     });
//     items.forEach(item => {
//         let max_height = item.querySelector(".accordion-content").scrollHeight;
//         item.querySelector(".accordion-content").style.setProperty("--max-height",max_height+"px");
//         item.querySelector(".accordion-content").style.setProperty("max-height","0px");
//     });
//   });
// }
function accordion() {
  const faqGroups = document.querySelectorAll('[data-accordion-group]');
  faqGroups.forEach(group => {
    let mobileOnly = false;
    if (group.dataset.accordionMobileOnly) {
      mobileOnly = true;
    }
    if (mobileOnly && !isMobile()) {
      return;
    }
    let openFirst = group.hasAttribute("data-accordion-open-first");
    const faqItems = group.querySelectorAll('[data-accordion-item]');
    // if(openFirst != null && faqItems[0])
    // {
    //   faqItems[0].classList.add("is-open")
    // }
    faqItems.forEach(item => {
      const btn = item.querySelector('[data-accordion-button]');
      const answer = item.querySelector('[data-accordion-content]');
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        faqItems.forEach(i => {
          i.classList.remove('is-open');
          i.querySelector('.product-how-to-use-video video')?.pause();
        });
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });
}

function initProductHowToUseVideos(scope = document) {
  scope.querySelectorAll('[data-product-how-to-use-video]').forEach(wrapper => {
    if (wrapper.dataset.videoToggleBound === 'true') return;

    const video = wrapper.querySelector('video');
    const toggle = wrapper.querySelector('[data-product-how-to-use-video-toggle]');
    if (!video || !toggle) return;

    wrapper.dataset.videoToggleBound = 'true';
    video.controls = false;
    video.playsInline = true;
    const supportsHover = window.matchMedia('(hover: hover)').matches;
    let hideControlsTimer;

    const clearHideControlsTimer = () => {
      window.clearTimeout(hideControlsTimer);
    };

    const revealControls = () => {
      clearHideControlsTimer();
      wrapper.classList.add('is-controls-visible');

      if (!video.paused && !supportsHover) {
        hideControlsTimer = window.setTimeout(() => {
          wrapper.classList.remove('is-controls-visible');
        }, 1800);
      }
    };

    const syncToggle = () => {
      const isPaused = video.paused || video.ended;
      toggle.classList.toggle('is-paused', isPaused);
      wrapper.classList.toggle('is-playing', !isPaused);
      toggle.setAttribute('aria-label', isPaused ? 'Play directions of use video' : 'Pause directions of use video');

      if (isPaused) {
        clearHideControlsTimer();
        wrapper.classList.add('is-controls-visible');
      } else {
        revealControls();
      }
    };

    toggle.addEventListener('click', () => {
      if (video.paused || video.ended) {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(syncToggle);
        }
      } else {
        video.pause();
      }
    });

    video.addEventListener('click', () => {
      if (!video.paused && !supportsHover) revealControls();
    });

    ['play', 'pause', 'ended', 'error'].forEach(event => video.addEventListener(event, syncToggle));
    syncToggle();
  });
}

function initProductCardHoverVideos(scope = document) {
  scope.querySelectorAll('.products-section .product-hover-video').forEach(video => {
    if (video.dataset.hoverVideoBound === 'true') return;

    const card = video.closest('.product-card-inner');
    if (!card) return;

    video.dataset.hoverVideoBound = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.controls = false;

    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    const playVideo = () => {
      if (!supportsHover.matches) return;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const pauseVideo = () => video.pause();

    card.addEventListener('mouseenter', playVideo);
    card.addEventListener('mouseleave', pauseVideo);
  });
}

function initRoutineBundleAccordions(scope = document) {
  scope.querySelectorAll('[data-routine-bundle]').forEach(bundle => {
    if (bundle.dataset.routineBundleBound === 'true') return;

    const toggle = bundle.querySelector('.routine-bundle__toggle');
    const panel = bundle.querySelector('.routine-bundle__panel');
    if (!toggle || !panel) return;

    bundle.dataset.routineBundleBound = 'true';

    const setExpanded = expanded => {
      bundle.classList.toggle('is-open', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        expanded ? 'Close recommended routine details' : 'Open recommended routine details'
      );
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');

      if (expanded) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    };

    setExpanded(toggle.getAttribute('aria-expanded') === 'true');
    toggle.addEventListener('click', () => {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });
  });
}
function playPauseVideos() {
  let all_videos = document.querySelectorAll(".c-video");
  if (all_videos.length < 1) return;
  all_videos.forEach(video_container => {
    let btn = video_container.querySelector(".play-btn");
    let video = video_container.querySelector("video")
    let status = false;
    btn.addEventListener("click", function () {
      status = !status;
      if (status) {
        video.play();
        video_container.classList.add("active");
      }
      else {
        video.pause();
        video_container.classList.remove("active");
      }
    })
  });
}
function videoPopup() {
  let videoPopup = document.querySelector(".video-popup");
  if (!videoPopup) return;
  let play_btns = document.querySelectorAll(".play-btn[data-link]");
  let close_btn = videoPopup.querySelector(".close-btn");
  let mute_btn = videoPopup.querySelector(".toggle-mute");
  if (play_btns.length < 1) return;
  play_btns.forEach(btn => {
    btn.addEventListener("click", function () {
      let link = btn.getAttribute("data-link");
      videoPopup.querySelector("video").setAttribute("src", link);
      videoPopup.classList.add("is-show");
      videoPopup.querySelector("video").play();
    })
  });
  close_btn.addEventListener("click", function () {
    videoPopup.classList.remove("is-show");
    videoPopup.querySelector("video").pause();
  })
  mute_btn.addEventListener("click", function () {
    let video = videoPopup.querySelector("video");
    let status = video.muted;
    video.muted = !status;
    mute_btn.classList.toggle("active", !status);
  })
}
// function productSwiperMain() {
//   let swiperMain = document.querySelector(".product-swiper-main");
//   let swiperThumbs = document.querySelector(".thumbnail-slider");
//   if (!swiperMain || !swiperThumbs) return;

//   // Initialize thumbnail slider first
//   const swiperThumbsSwiper = new Swiper('.thumbnail-slider', {
//     direction: 'vertical',
//     slidesPerView: 4,
//     spaceBetween: 10,
//     watchSlidesProgress: true, // Required for thumbs controller
//     breakpoints: {
//       320: {
//         slidesPerView: 3,
//         spaceBetween: 10,
//       },
//       768: {
//         slidesPerView: 5,
//         spaceBetween: 20,
//       }
//     },
//     navigation: {
//       nextEl: '.thumbnail-slider .swiper-button-next',
//       prevEl: '.thumbnail-slider .swiper-button-prev',
//     },

//   });

//   // Initialize main slider with thumbs controller
//   const swiper = new Swiper('.product-swiper-main', {
//     slidesPerView: 1,
//     spaceBetween: 15,
//     thumbs: {
//       swiper: swiperThumbsSwiper, // Link to thumbs swiper
//     },
//     navigation: {
//       nextEl: '.product-swiper-main .swiper-button-next',
//       prevEl: '.product-swiper-main .swiper-button-prev',
//     },
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     breakpoints: {
//       768: {
//         pagination: false,
//       }
//     }

//   });
// }
function productSwiperMain() {
  let swiperMain = document.querySelector(".product-swiper-main");
  if (!swiperMain) return;

  let gallery = swiperMain.closest("media-gallery");
  let thumbnailSlider = (gallery || swiperMain.parentElement).querySelector(".thumbnail-slider");
  let thumbnails = thumbnailSlider ? thumbnailSlider.querySelectorAll(".swiper-slide") : [];
  const videoToggle = swiperMain.querySelector("[data-product-gallery-video-toggle]");
  const muteToggle = swiperMain.querySelector("[data-product-gallery-mute-toggle]");
  let activeVideo = null;

  function updateVideoToggle() {
    // A removed variant video can still fire pause/play after the gallery is rebuilt.
    // Only the current Swiper instance may change the shared corner button.
    if (swiperMain.productGalleryToggleOwner !== updateVideoToggle) return;
    const activeSlide = swiperMain.querySelector('.swiper-slide-active');
    const videoIsActive = activeVideo?.isConnected && activeSlide?.contains(activeVideo);
    if (videoToggle) videoToggle.hidden = !videoIsActive;
    if (muteToggle) muteToggle.hidden = !videoIsActive;
    if (!videoIsActive) return;
    if (videoToggle) {
      videoToggle.classList.toggle("is-paused", activeVideo.paused);
      videoToggle.setAttribute("aria-label", activeVideo.paused ? "Play video" : "Pause video");
    }
    if (muteToggle) {
      muteToggle.classList.toggle("is-muted", activeVideo.muted);
      muteToggle.setAttribute("aria-label", activeVideo.muted ? "Unmute video" : "Mute video");
      muteToggle.setAttribute("aria-pressed", String(!activeVideo.muted));
    }
  }

  swiperMain.productGalleryToggleOwner = updateVideoToggle;

  function syncActiveMedia(instance) {
    const activeSlide = instance.slides[instance.activeIndex];
    activeVideo = null;
    updateVideoToggle();

    swiperMain.querySelectorAll("video").forEach(video => {
      if (activeSlide && activeSlide.contains(video)) return;
      // A variant may reuse this video element. Remove its previous gallery
      // listener before pausing so it cannot restore the play button on an image.
      if (video.productGalleryPlaybackHandler) {
        ["play", "pause", "ended", "volumechange"].forEach(event => {
          video.removeEventListener(event, video.productGalleryPlaybackHandler);
        });
        video.productGalleryPlaybackHandler = null;
      }
      video.pause();
    });
    swiperMain.querySelectorAll(".js-youtube, .js-vimeo").forEach(frame => {
      if (activeSlide && activeSlide.contains(frame)) return;
      if (!frame.contentWindow) return;
      const message = frame.classList.contains("js-youtube")
        ? { event: "command", func: "pauseVideo", args: "" }
        : { method: "pause" };
      frame.contentWindow.postMessage(JSON.stringify(message), "*");
    });

    if (!activeSlide) return;
    const deferredMedia = activeSlide.querySelector("deferred-media");
    if (deferredMedia && !deferredMedia.hasAttribute("loaded")) {
      deferredMedia.loadContent(false);
    }

    const video = activeSlide.querySelector("video");
    if (video) {
      activeVideo = video;
      video.controls = false;
      video.loop = true;
      // Start gallery videos with sound. If audible autoplay is blocked, the
      // existing play button lets the visitor start playback with a tap.
      video.muted = false;
      video.defaultMuted = false;
      video.playsInline = true;
      video.removeAttribute("muted");
      video.setAttribute("playsinline", "");
      if (video.productGalleryPlaybackHandler) {
        ["play", "pause", "ended", "volumechange"].forEach(event => {
          video.removeEventListener(event, video.productGalleryPlaybackHandler);
        });
      }
      video.productGalleryPlaybackHandler = updateVideoToggle;
      ["play", "pause", "ended", "volumechange"].forEach(event => {
        video.addEventListener(event, video.productGalleryPlaybackHandler);
      });
      updateVideoToggle();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        // Keep the manual play button available if the device blocks autoplay.
        playPromise.catch(updateVideoToggle);
      }
    } else if (deferredMedia) {
      const frame = deferredMedia.querySelector(".js-youtube, .js-vimeo");
      if (!frame || !frame.contentWindow) return;
      const message = frame.classList.contains("js-youtube")
        ? { event: "command", func: "playVideo", args: "" }
        : { method: "play" };
      frame.contentWindow.postMessage(JSON.stringify(message), "*");
    }
  }

  // If a Swiper instance already lives on this element (e.g. after a
  // variant-change DOM patch), tear it down before rebuilding so we don't
  // leak instances or end up with stale slide references.
  if (swiperMain.swiper) {
    swiperMain.swiper.destroy(true, true);
  }

  const swiper = new Swiper(swiperMain, {
    slidesPerView: 1,
    spaceBetween: 15,
    navigation: {
      nextEl: swiperMain.querySelector('.swiper-button-next'),
      prevEl: swiperMain.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: swiperMain.querySelector('.swiper-pagination'),
      clickable: true,
    },
    breakpoints: {
      768: {
        pagination: false,
      }
    },
    on: {
      init: function () {
        syncActiveMedia(this);
      },
      slideChange: function () {
        updateActiveThumb(this.activeIndex);
        syncActiveMedia(this);
      }
    }
  });

  function updateActiveThumb(index) {
    thumbnails.forEach(thumb => {
      thumb.classList.remove('is-active');
      const thumbnail = thumb.querySelector('.thumbnail');
      if (thumbnail) thumbnail.removeAttribute('aria-current');
    });

    const activeThumb = thumbnails[index];
    if (!activeThumb) return;
    activeThumb.classList.add('is-active');
    const thumbnail = activeThumb.querySelector('.thumbnail');
    if (thumbnail) thumbnail.setAttribute('aria-current', 'true');

    // Scroll only the thumbnail strip, keeping neighbours visible in either direction.
    if (!thumbnailSlider.clientHeight || !thumbnailSlider.clientWidth) return;
    const stripRect = thumbnailSlider.getBoundingClientRect();
    const thumbRect = activeThumb.getBoundingClientRect();
    const maxTop = thumbnailSlider.scrollHeight - thumbnailSlider.clientHeight;
    const maxLeft = thumbnailSlider.scrollWidth - thumbnailSlider.clientWidth;
    const targetTop = thumbnailSlider.scrollTop + thumbRect.top - stripRect.top
      - (thumbnailSlider.clientHeight - thumbRect.height) / 2;
    const targetLeft = thumbnailSlider.scrollLeft + thumbRect.left - stripRect.left
      - (thumbnailSlider.clientWidth - thumbRect.width) / 2;
    thumbnailSlider.scrollTo({
      top: Math.max(0, Math.min(maxTop, targetTop)),
      left: Math.max(0, Math.min(maxLeft, targetLeft)),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  if (videoToggle) {
    if (videoToggle.productGalleryClickHandler) {
      videoToggle.removeEventListener('click', videoToggle.productGalleryClickHandler);
    }
    videoToggle.productGalleryClickHandler = event => {
      event.stopPropagation();
      if (!activeVideo) return;
      if (activeVideo.paused) {
        const playPromise = activeVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(updateVideoToggle);
        }
      } else {
        activeVideo.pause();
      }
    };
    videoToggle.addEventListener('click', videoToggle.productGalleryClickHandler);
  }

  if (muteToggle) {
    if (muteToggle.productGalleryClickHandler) {
      muteToggle.removeEventListener('click', muteToggle.productGalleryClickHandler);
    }
    muteToggle.productGalleryClickHandler = event => {
      event.stopPropagation();
      if (!activeVideo) return;
      activeVideo.muted = !activeVideo.muted;
      updateVideoToggle();
    };
    muteToggle.addEventListener('click', muteToggle.productGalleryClickHandler);
  }

  thumbnails.forEach((thumb, index) => {
    if (thumb.productGalleryClickHandler) {
      thumb.removeEventListener('click', thumb.productGalleryClickHandler);
    }
    thumb.productGalleryClickHandler = () => {
      if (swiper.activeIndex === index) updateActiveThumb(index);
      else swiper.slideTo(index);
    };
    thumb.addEventListener('click', thumb.productGalleryClickHandler);
  });

  // Set initial active thumbnail
  updateActiveThumb(0);
}
// Exposed globally (this script runs as a plain, non-module script, so
// top-level function declarations already attach to window — this call is
// made explicit for readability) so product-info.js can re-run it after
// patching the media gallery DOM on variant change.
window.productSwiperMain = productSwiperMain;
function upsellSwiper() {
  let swiperUpsell = document.querySelector(".upsell-box .swiper");
  if (swiperUpsell.classList.contains("is-initialized")) {
    swiperUpsellSwiper.destroy();
    swiperUpsell.classList.remove("is-initialized");
  }
  if (!swiperUpsell) return;
  const swiperUpsellSwiper = new Swiper('.upsell-box .swiper', {
    slidesPerView: 1.8,
    spaceBetween: 15,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      }
    },
    // navigation: {
    //     nextEl: '.swiper-wrapper .swiper-button-next',
    //     prevEl: '.swiper-wrapper .swiper-button-prev',
    // },
  });
}
function cartDrawer() {
  let cartOpener = document.querySelector("#cart-opener");
  if (!cartOpener) return;
  cartOpener.addEventListener("click", function () {
    document.querySelector(".cart-drawer").classList.add("is-show");
  })
}
function cart() {

  const drawer = document.querySelector("#CartDrawer");
  const closeBtn = drawer.querySelector(".close-cart");
  const cartOverlay = document.querySelector(".cart-close-overlay")
  const storeCurrency = "₹";
  // document.querySelectorAll(".milestone").forEach((milestone) => {
  //   let rate = Number(Shopify.currency.rate);
  //   let milestonePrice = Number(milestone.dataset.threshold);
  //   let milestoneAmount = milestonePrice * rate;
  //   milestone.setAttribute("data-threshold", milestoneAmount.toFixed(2));
  // })
  /* -----------------------------
     Helper – Fetch Latest Cart
  ------------------------------ */


  function fetchCart() {
    return fetch("/cart.js").then(res => res.json());
  }

  if (drawer.querySelectorAll(".cart-item").length < 1) {
    drawer.classList.add("is-empty");
  }
  else {
    drawer.classList.remove("is-empty");
  }

  /* -----------------------------
     Render Cart After Updates
  ------------------------------ */
  window.reloadCart = function () {
    fetch(window.location.pathname + "?section_id=cart-drawer")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newDrawer = doc.querySelector("#CartDrawer");
        let items = newDrawer.querySelector(".cart-items");
        drawer.querySelector(".cart-items").innerHTML = items.innerHTML;
        const cartFooter = newDrawer.querySelector(".cart-footer");
        drawer.querySelector(".cart-footer").innerHTML = cartFooter.innerHTML;
        const upsellBox = newDrawer.querySelector(".upsell-box");
        const currentUpsellBox = drawer.querySelector(".upsell-box");
        if (upsellBox && currentUpsellBox) {
          currentUpsellBox.innerHTML = upsellBox.innerHTML;
        }
        const cart_summary = newDrawer.querySelector(".cart-summary-wrap");
        drawer.querySelector(".cart-summary-wrap").innerHTML = cart_summary.innerHTML;
        const cart_count = newDrawer.querySelector(".cart-item-count");
        document.querySelector(".cart__count").innerHTML = cart_count.innerHTML;
        attachCartEvents(); // rebind events
        if (items.querySelectorAll(".cart-item").length < 1) {
          drawer.classList.add("is-empty");
        }
        else {
          drawer.classList.remove("is-empty");
        }
      });
  }
  window.checkCartCount = function () {
    fetch(window.location.pathname + "?section_id=cart-drawer")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newDrawer = doc.querySelector("#CartDrawer");
        let items = newDrawer.querySelector(".cart-items");
        if (items.querySelectorAll(".cart-item").length == 0) {
          drawer.querySelector(".cart-item-count").innerHTML = 0;
        }
        else {
          const cartCount = newDrawer.querySelector(".cart-item-count");

        }
        return items.querySelectorAll(".cart-item").length
      });
  }

  /* -----------------------------
     Open Drawer
  ------------------------------ */
  window.openCart = function () {
    drawer.classList.add("drawer--is-open");
    if (drawer.querySelectorAll(".cart-item").length < 1) {
      drawer.classList.add("is-empty");
    } else {
      drawer.classList.remove("is-empty");
    }
  };

  /* -----------------------------
     Close Drawer
  ------------------------------ */
  closeBtn.addEventListener("click", () => {
    drawer.classList.remove("drawer--is-open");
  });
  cartOverlay.addEventListener("click", () => {
    drawer.classList.remove("drawer--is-open");
  });

  /* -----------------------------
     Update Quantity
  ------------------------------ */
  function updateCartLine(lineKey, quantity, triggerEl = null) {

    // Add updating class
    if (triggerEl) {
      triggerEl.classList.add("is-updating");
      triggerEl.disabled = true;
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity })
    })
      .then(() => reloadCart())
      .finally(() => {
        if (triggerEl) {
          triggerEl.classList.remove("is-updating");
          triggerEl.disabled = false;
        }
      });
  }


  /* -----------------------------
     Remove Item
  ------------------------------ */
  function removeItem(lineKey, btn = null) {
    return updateCartLine(lineKey, 0, btn);
  }

  /* -----------------------------
     Add Product / Upsell
  ------------------------------ */
  function addToCart(variantId, quantity = 1) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity })
    })
      .then(() => reloadCart())
      .then(() => openCart());
  }

  /* -----------------------------
     Handle Shipping Protection
  ------------------------------ */
  function toggleShippingProtection(enabled, variantId) {
    fetchCart().then(cart => {
      const alreadyAdded = cart.items.find(i => i.id == variantId);
      if (enabled && !alreadyAdded) {
        addToCart(variantId);
      } else if (!enabled && alreadyAdded) {
        removeItem(alreadyAdded.key);
      }
    });
  }

  window.toggleFreeProduct = function (enabled, variantId) {
    fetchCart().then(cart => {
      const alreadyAdded = cart.items.find(i => i.id == variantId);
      if (enabled && !alreadyAdded) {
        addToCart(variantId);
      } else if (!enabled && alreadyAdded) {
        removeItem(alreadyAdded.key);
      }
    });
  }
  /* -----------------------------
     Free Shipping Bar Logic
  ------------------------------ */
  function updateShippingBar(cart) {
    const settings = window.cartSettings || {};
    let cartTotal = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
    const rate = Number(Shopify.currency.rate);

    const messageEl = document.querySelector("#amount-away");
    const milestones = Array.from(document.querySelectorAll(".milestone"));
    if (!messageEl || milestones.length === 0) return;

    // Sort milestones
    milestones.sort((a, b) => Number(a.dataset.threshold) - Number(b.dataset.threshold));
    const thresholds = milestones.map(m => Number(m.dataset.threshold) * 100);

    // Step-by-step fill
    milestones.forEach((milestone, idx) => {
      const current = thresholds[idx];
      const prev = idx === 0 ? 0 : thresholds[idx - 1];
      let percent = 0;

      if (cartTotal >= current) {
        percent = 100;
        milestone.classList.add("active");
      } else if (cartTotal > prev) {
        percent = ((cartTotal - prev) / (current - prev)) * 100;
        milestone.classList.remove("active");
      } else {
        milestone.classList.remove("active");
      }
      milestone.style.setProperty("--milestone-width", `${Math.min(100, percent)}%`);
    });

    function formatCents(cents) {
      return `${storeCurrency}${(Math.max(0, cents) / 100).toFixed(2)}`;
    }

    // -------------------------
    // DETERMINE ONLY THE NEXT MILESTONE
    // -------------------------

    const freeShippingUnlocked = settings.free_shipping_enabled && cartTotal >= Number(settings.free_shipping_threshold * rate);
    const freeGiftUnlocked = settings.enable_free_gift && cartTotal >= Number(settings.free_gift_threshold * rate);
    const expressUnlocked = settings.free_express_shipping_enabled && cartTotal >= Number(settings.free_express_shipping_threshold * rate);

    let nextMessage = "";

    // 1. Next: Free Shipping
    if (settings.free_shipping_enabled && !freeShippingUnlocked) {
      const diff = Number(settings.free_shipping_threshold * rate) - cartTotal;
      nextMessage = settings.free_shipping_text.replace("{{price}}", formatCents(diff));


    }


    // 2. Next: Free Gift
    else if (settings.enable_free_gift && !freeGiftUnlocked) {
      const diff = Number(settings.free_gift_threshold * rate) - cartTotal;
      nextMessage = settings.free_gift_text.replace("{{price}}", formatCents(diff));
    }

    // 3. Next: Free Express
    else if (settings.free_express_shipping_enabled && !expressUnlocked) {
      const diff = Number(settings.free_express_shipping_threshold * rate) - cartTotal;
      nextMessage = settings.free_express_shipping_text.replace("{{price}}", formatCents(diff));
    }

    // 4. ALL unlocked
    else {
      nextMessage = settings.free_shipping_final_message;
    }
    if (settings.enable_free_gift && freeGiftUnlocked) {
      toggleFreeProduct(true, settings.free_product_product_id);
    }
    else {
      toggleFreeProduct(false, settings.free_product_product_id);
    }

    messageEl.innerHTML = nextMessage;
  }




  /* -----------------------------
     Attach Events to Drawer
  ------------------------------ */
  function attachCartEvents() {
    drawer.querySelectorAll(".plus").forEach(btn => {
      btn.addEventListener("click", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        const qtyInput = item.querySelector("input");
        updateCartLine(key, Number(qtyInput.value) + 1, btn);
      });
    });

    drawer.querySelectorAll(".minus").forEach(btn => {
      btn.addEventListener("click", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        const qtyInput = item.querySelector("input");
        const newQty = Math.max(0, Number(qtyInput.value) - 1);
        updateCartLine(key, newQty, btn);
      });
    });
    drawer.querySelectorAll("[type='number']").forEach(input => {
      input.addEventListener("focusout", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        const qtyInput = item.querySelector("input");
        const newQty = Math.max(1, Number(qtyInput.value));
        updateCartLine(key, newQty);
      });
    });

    drawer.querySelectorAll(".remove").forEach(btn => {
      btn.addEventListener("click", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        removeItem(key, btn);
      });
    });

    drawer.querySelectorAll(".add-to-cart").forEach(btn => {
      btn.addEventListener("click", e => {
        const id = e.target.dataset.variantId;
        addToCart(id, btn);
      });
    });

    // upsellSwiper();
    //     document.querySelector('#CartNote').addEventListener('focusout', function(e) {
    //   updateCartNote(e.target.value);
    // });
    // document.querySelector(".cart-note-toggler").addEventListener("click", function (e) {
    //     e.preventDefault();
    //     document.querySelector(".cart-note-wrap").classList.toggle("is-active");
    //   })

    // SHIPPING PROTECTION
    // const spCheckbox = document.querySelector("#shipping_protection_product");
    // if (spCheckbox) {
    //   const spVariant = spCheckbox.getAttribute("data-id");

    //   spCheckbox.addEventListener("change", () => {
    //     toggleShippingProtection(spCheckbox.checked, spVariant);
    //   });
    // }

    // Update shipping bar after render
    fetchCart().then(cart => updateShippingBar(cart));
  }


  /* Init */
  attachCartEvents();

  function updateCartState(cart) {
    if (window.checkCartCount() == undefined) {
      document.querySelector(".cart-link__bubble").classList.remove('cart-link__bubble--visible');
    }
    else {
      document.querySelector(".cart-link__bubble").classList.add('cart-link__bubble--visible');
    }
  }
  function addOrIncrementCartItem(variantId, triggerEl = null) {

    // Add loading class
    if (triggerEl) {
      triggerEl.classList.add("is-updating");
      triggerEl.disabled = true;
    }
    let preorder = false;
    let preorder_input = triggerEl.querySelector("[name='properties[Pre-order]']");

    if (preorder_input && preorder_input.value == "Yes") {
      preorder = true;
    }

    jQuery.getJSON('/cart.js', function (cart) {

      let lineIndex = null;
      let currentQty = 0;

      cart.items.forEach((item, index) => {
        if (item.variant_id == variantId) {
          lineIndex = index + 1;
          currentQty = item.quantity;
        }
      });

      const onDone = () => {
        reloadCart();
        openCart();

        // Remove loading state
        if (triggerEl) {
          triggerEl.classList.remove("is-updating");
          triggerEl.disabled = false;
        }
      };

      if (lineIndex) {
        if (preorder) {
          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              line: lineIndex, quantity: currentQty + 1, properties: {
                "Order Type": "Pre-order"
              }
            },
            dataType: 'json',
            success: onDone,
            error: onDone
          });
        }
        else {
          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { line: lineIndex, quantity: currentQty + 1 },
            dataType: 'json',
            success: onDone,
            error: onDone
          });
        }

      } else {
        if (preorder) {

          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: variantId, quantity: 1,
              properties: {
                "Order Type": "Pre-order"
              }
            },
            dataType: 'json',
            success: onDone,
            error: onDone
          });
        }
        else {
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: variantId, quantity: 1
            },
            dataType: 'json',
            success: onDone,
            error: onDone
          });
        }
      }
    });
  }




  document.querySelector("#cart-opener").addEventListener("click", function (e) {
    e.preventDefault();
    openCart();
  });
  window.checkCartCount();


  jQuery(document).on("submit", ".quick-cart, .quick--add", function (e) {
    e.preventDefault();

    let dataID = jQuery(this).find("textarea").val()
    let formData = jQuery(this).serialize();
    let id = jQuery(this).find("input[name=id]").val();
    e.preventDefault();
    try {
      addOrIncrementCartItem(id, e.target);

    }
    catch (error) {
      console.error('Add to cart failed:', error);
    }
  })


  function updateCartNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    })
      .then(res => res.json())
      .then(cart => {
      })
      .catch(err => console.error("Note update failed:", err));
  }


}
function backToTop() {
  document.querySelector(".back-top-top").addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' })
  });
}
document.addEventListener("scroll", function () {
  const windowHeight = window.innerHeight;
  if (window.scrollY > windowHeight / 2) {
    document.querySelector(".back-top-top").classList.add("show");
  } else {
    document.querySelector(".back-top-top").classList.remove("show");
  }
});
function provenByDesign() {
  if (document.querySelectorAll('.proven-swiper').length == 0) {
    return;
  }
  document.querySelectorAll('.proven-results').forEach(function (el) {
    var isMobileV2 = !!el.closest('.proven-section--mobile-v2');
    var useMobilePagination = isMobileV2 && window.innerWidth <= 767;
    var paginationEl = el.querySelector('.proven-results-pagination');
    var imageSwiperConfig = {
      loop: true,
      effect: 'slide',
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
    };

    if (useMobilePagination && paginationEl) {
      imageSwiperConfig.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    var legacyPagination = el.querySelector('.swiper-pagination');
    if (!imageSwiperConfig.pagination && legacyPagination) {
      imageSwiperConfig.pagination = {
        el: legacyPagination,
        clickable: true,
      };
    }

    const imageSwiper = new Swiper(
      el.querySelector('.proven-card__images'),
      imageSwiperConfig
    );

    function updateProvenSliderMeta(swiper) {
      if (!isMobileV2 || window.innerWidth > 767) return;

      var sliderGroup = el.querySelector('.proven-results-slider-group');
      var counter = el.querySelector('[data-proven-counter]');
      var slideCount = el.querySelectorAll('.proven-swiper .swiper-slide:not(.swiper-slide-duplicate)').length;
      if (!slideCount) {
        slideCount = el.querySelectorAll('.proven-swiper .swiper-slide').length;
      }

      if (!sliderGroup || !counter) return;

      if (slideCount <= 1) {
        sliderGroup.classList.add('is-single-slide');
        counter.textContent = '';
        return;
      }

      sliderGroup.classList.remove('is-single-slide');
      counter.textContent = (swiper.realIndex + 1) + ' / ' + slideCount;
    }

    imageSwiper.on('slideChange', function () {
      updateProvenSliderMeta(imageSwiper);
    });
    updateProvenSliderMeta(imageSwiper);

let contentSwiper = new Swiper(
  el.querySelector('.proven-card__content_inner'),
  {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  }
);

if(window.innerWidth <= 999) {
  contentSwiper = new Swiper(
  el.querySelector('.proven-card__content_inner2'), 
  {
    loop: true,
    effect: 'fade',
        autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: true,
  }
);
}


// Sync both sliders
imageSwiper.controller.control = contentSwiper;
contentSwiper.controller.control = imageSwiper;
    
  });

  // Tab switching
  const tabs = document.querySelectorAll('.proven-tab');
  const results = document.querySelectorAll('.proven-results');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const target = this.dataset.tab;

      tabs.forEach(t => t.classList.remove('proven-tab--active'));
      results.forEach(r => r.classList.remove('proven-results--active'));

      this.classList.add('proven-tab--active');
      document.querySelector('[data-results="' + target + '"]').classList.add('proven-results--active');
    });
  });
}
function provenSlider() {
  if (document.querySelectorAll('.proven-swiper').length == 0) {
    return;
  }
  document.querySelectorAll('.proven-swiper').forEach(function (el) {
    new Swiper(el, {
      loop: true,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
    });
  });
}
function initCascadingSlider() {
  const duration = 0.65;
  const ease = 'power3.inOut';
  const autoplayDelay = 4000;

  const breakpoints = [
    { maxWidth: 479, activeWidth: 0.78, siblingWidth: 0.08 },
    { maxWidth: 767, activeWidth: 0.7, siblingWidth: 0.1 },
    { maxWidth: 991, activeWidth: 0.6, siblingWidth: 0.1 },
    { maxWidth: Infinity, activeWidth: 0.6, siblingWidth: 0.13 },
  ];

  const wrappers = document.querySelectorAll('[data-cascading-slider-wrap]');
  wrappers.forEach(setupInstance);

  function setupInstance(wrapper) {
    const viewport = wrapper.querySelector('[data-cascading-viewport]');
    const slides = Array.from(viewport.querySelectorAll('[data-cascading-slide]'));
    let totalSlides = slides.length;
    const originalCount = totalSlides;

    if (totalSlides === 0) return;

    if (totalSlides < 9) {
      const originalSlides = slides.slice();
      while (slides.length < 9) {
        originalSlides.forEach(function (original) {
          const clone = original.cloneNode(true);
          clone.setAttribute('data-clone', '');
          viewport.appendChild(clone);
          slides.push(clone);
        });
      }
      totalSlides = slides.length;
    }

    // Start at index 1 so the first original slide sits at offset -1 (left sibling)
    let activeIndex = 1;
    let isAnimating = false;
    let slideWidth = 0;
    let slotCenters = {};
    let slotWidths = {};
    let autoplayTimer = null;
    let progressTween = null;

    function readGap() {
      const raw = getComputedStyle(viewport).getPropertyValue('--gap').trim();
      if (!raw) return 0;
      const temp = document.createElement('div');
      temp.style.width = raw;
      temp.style.position = 'absolute';
      temp.style.visibility = 'hidden';
      viewport.appendChild(temp);
      const px = temp.offsetWidth;
      viewport.removeChild(temp);
      return px;
    }

    function getSettings() {
      const windowWidth = window.innerWidth;
      for (let i = 0; i < breakpoints.length; i++) {
        if (windowWidth <= breakpoints[i].maxWidth) return breakpoints[i];
      }
      return breakpoints[breakpoints.length - 1];
    }

    function getOffset(slideIndex, fromIndex) {
      if (fromIndex === undefined) fromIndex = activeIndex;
      let distance = slideIndex - fromIndex;
      const half = totalSlides / 2;
      if (distance > half) distance -= totalSlides;
      if (distance < -half) distance += totalSlides;
      return distance;
    }

    function measure() {
      const settings = getSettings();
      const viewportWidth = viewport.offsetWidth;
      const gap = readGap();

      const activeSlideWidth = viewportWidth * settings.activeWidth;
      const siblingSlideWidth = viewportWidth * settings.siblingWidth;
      const farSlideWidth = Math.max(0, (viewportWidth - activeSlideWidth - 2 * siblingSlideWidth - 4 * gap) / 2);

      slideWidth = activeSlideWidth;

      const visibleSlots = [
        { slot: -2, width: farSlideWidth },
        { slot: -1, width: siblingSlideWidth },
        { slot: 0, width: activeSlideWidth },
        { slot: 1, width: siblingSlideWidth },
        { slot: 2, width: farSlideWidth },
      ];

      let x = 0;
      visibleSlots.forEach(function (def, i) {
        slotCenters[String(def.slot)] = x + def.width / 2;
        slotWidths[String(def.slot)] = def.width;
        if (i < visibleSlots.length - 1) x += def.width + gap;
      });

      slotCenters['-3'] = slotCenters['-2'] - farSlideWidth / 2 - gap - farSlideWidth / 2;
      slotWidths['-3'] = farSlideWidth;
      slotCenters['3'] = slotCenters['2'] + farSlideWidth / 2 + gap + farSlideWidth / 2;
      slotWidths['3'] = farSlideWidth;

      slides.forEach(function (slide) {
        slide.style.width = slideWidth + 'px';
      });
    }

    function getSlideProps(offset) {
      const clamped = Math.max(-3, Math.min(3, offset));
      const slotWidth = slotWidths[String(clamped)];
      const clipAmount = Math.max(0, (slideWidth - slotWidth) / 2);
      const translateX = slotCenters[String(clamped)] - slideWidth / 2;
      return {
        x: translateX,
        '--clip': clipAmount,
        zIndex: 10 - Math.abs(clamped),
      };
    }

    function layout(animate, previousIndex) {
      slides.forEach(function (slide, index) {
        const offset = getOffset(index);

        if (offset < -3 || offset > 3) {
          if (animate && previousIndex !== undefined) {
            const previousOffset = getOffset(index, previousIndex);
            if (previousOffset >= -2 && previousOffset <= 2) {
              const exitSlot = previousOffset < 0 ? -3 : 3;
              gsap.to(
                slide,
                Object.assign({}, getSlideProps(exitSlot), {
                  duration: duration,
                  ease: ease,
                  overwrite: true,
                })
              );
              return;
            }
          }
          const parkSlot = offset < 0 ? -3 : 3;
          gsap.set(slide, getSlideProps(parkSlot));
          return;
        }

        const props = getSlideProps(offset);
        slide.setAttribute('data-status', offset === 0 ? 'active' : 'inactive');

        if (animate) {
          gsap.to(
            slide,
            Object.assign({}, props, {
              duration: duration,
              ease: ease,
              overwrite: true,
            })
          );
        } else {
          gsap.set(slide, props);
        }
      });
    }

    function startProgressBar() {
      if (progressTween) progressTween.kill();

      // Reset all fills
      slides.forEach(function (slide) {
        const fill = slide.querySelector('.cascading-slider__progress-fill');
        if (fill) gsap.set(fill, { width: '0%' });
      });

      // Animate only the active slide's fill
      const activeSlide = slides[activeIndex];
      if (activeSlide) {
        const fill = activeSlide.querySelector('.cascading-slider__progress-fill');
        if (fill) {
          progressTween = gsap.to(fill, {
            width: '100%',
            duration: autoplayDelay / 1000,
            ease: 'none',
          });
        }
      }
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
      if (progressTween) {
        progressTween.kill();
        progressTween = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      startProgressBar();
      autoplayTimer = setTimeout(function () {
        goTo(activeIndex + 1);
      }, autoplayDelay);
    }

    function goTo(targetIndex) {
      const normalizedTarget = ((targetIndex % totalSlides) + totalSlides) % totalSlides;
      if (isAnimating || normalizedTarget === activeIndex) return;
      isAnimating = true;

      stopAutoplay();

      const previousIndex = activeIndex;
      const travelDirection = getOffset(normalizedTarget, previousIndex) > 0 ? 1 : -1;

      slides.forEach(function (slide, index) {
        const currentOffset = getOffset(index, previousIndex);
        const nextOffset = getOffset(index, normalizedTarget);
        const wasInRange = currentOffset >= -3 && currentOffset <= 3;
        const willBeVisible = nextOffset >= -2 && nextOffset <= 2;

        if (!wasInRange && willBeVisible) {
          const entrySlot = travelDirection > 0 ? 3 : -3;
          gsap.set(slide, getSlideProps(entrySlot));
        }

        const wasInvisible = Math.abs(currentOffset) >= 3;
        const willBeStaging = Math.abs(nextOffset) === 3;
        const crossesSides = currentOffset * nextOffset < 0;
        if (wasInvisible && willBeStaging && crossesSides) {
          gsap.set(slide, getSlideProps(nextOffset > 0 ? 3 : -3));
        }
      });

      activeIndex = normalizedTarget;
      layout(true, previousIndex);

      gsap.delayedCall(duration + 0.05, function () {
        isAnimating = false;
        startAutoplay();
      });
    }

    // Click slide to navigate
    slides.forEach(function (slide, index) {
      slide.addEventListener('click', function () {
        if (index !== activeIndex) goTo(index);
      });
    });

    // Keyboard
    document.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
      if (event.key === 'ArrowRight') goTo(activeIndex + 1);
    });

    // Resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        measure();
        layout(false);
      }, 100);
    });

    measure();
    layout(false);
    startAutoplay();
  }
}
function setDelays() {
  const delays = [...document.querySelectorAll("[delay]")];
  delays.forEach(function (e) {
    const delay = e.getAttribute("delay");
    e.style.setProperty("--delay", delay);
  });
  const delaysMobile = [...document.querySelectorAll("[delay-mobile]")];
  delaysMobile.forEach(function (e) {
    const delay = e.getAttribute("delay-mobile");
    e.style.setProperty("--delay-mobile", delay);
  });
  const fadeinGroups = [...document.querySelectorAll("[data-fadein-group]")];
  fadeinGroups.forEach(function (e) {
    Array.from(e.children).forEach((el, index) => {
      el.style.setProperty("--index", index);
    });
  });
  const fadeinGalleries = [...document.querySelectorAll("[data-fadein-gallery]")];
  fadeinGalleries.forEach(function (e) {
    Array.from(e.children).forEach((el, index) => {
      el.style.setProperty("--index", index);
    });
  });
}
function splitText() {
  const targets = [...document.querySelectorAll("[animation='textsplit']")];
  targets.forEach(function (el) {
    const split = new SplitText(el, { type: "lines", wordsClass: "word", linesClass: "line",  aria: "auto" });
    split.lines.forEach((line, index) => {
      line.style.setProperty("--index", index);
      new SplitText(line, { type: "lines", linesClass: "line-i", aria: "auto" });
    });
  });
  const founder_note = document.querySelector(".founder-text p");
  if (founder_note) {
    const founder_noteSplit = new SplitText(founder_note, { type: "words,chars", charsClass: "char", aria: "auto" });
    // founder_noteSplit.chars.forEach((char,index) => {
    //   char.style.setProperty("--index", index);
    // });
    setTimeout(() => {
      let tl = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          trigger: ".founder-section",
          start: "top+=50% bottom",
          end: "+=60%",
        }
      })
       tl.set(founder_noteSplit.chars, {
        opacity: 0.1,
      })
      tl.to(founder_noteSplit.chars, {
        opacity: 1,
        stagger: 0.05,
        ease: "linear"
      })
    }, 200);
  }

}
function headerHideShow() {
  let header = document.querySelector(".site-header");
  let lastScrollTop = 0;
  const delta = 5;
  let dvh = window.innerHeight;
  dvh = dvh - header.offsetHeight - 20;
  window.addEventListener("scroll", function () {
    let scrollTop = window.scrollY;
    if (scrollTop > 100) {
      header.classList.add("is-hide");
    } else {
      header.classList.remove("is-hide");
    }
  });


  function handleScroll() {
    const currentScroll = window.scrollY;
    let scrollThreshold = 100;

    if (Math.abs(currentScroll - lastScrollTop) <= delta) return;

    if (currentScroll > scrollThreshold && currentScroll > lastScrollTop) {
      header.classList.add('hide-header');
    } else {
      header.classList.remove('hide-header');
    }

    document.body.classList.toggle('is-header-scrolled', currentScroll >= scrollThreshold);
    lastScrollTop = currentScroll;
  }

  window.addEventListener('scroll', handleScroll);

}
function heroSectionAnimation() {
  let heroSection = document.querySelector(".hero-section");
  if (heroSection) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".hero-section",
        scrub: true,
        start: "top top",
        end: "+=100%",
      }
    });

    if (!isMobile()) {
      tl.to(".hero-section", {
        clipPath: "inset(30px 30px round 10px)",
        ease: "power1.out",
      }, 0) // start at same time

        .to(".hero-bg img", {
          scale: 1.02,
          ease: "power1.out",
        }, 0); // start at same time
    }
    else {
      tl.to(".hero-section", {
        clipPath: "inset(15px 15px round 10px)",
        ease: "power1.out",
      }, 0) // start at same time

        .to(".hero-bg img", {
          scale: 1.02,
          ease: "power1.out",
        }, 0) // start at same time

        .to(".hero-section .hero-content", {
          scale: 0.9,
          ease: "power1.out",
        }, 0) // start at same time

        .to(".hero-pagination.swiper-pagination", {
          x: -15,
          ease: "power1.out",
        }, 0); // start at same time


    }
  }
}
function initFooterParallax() {
  document.querySelectorAll('[data-footer-parallax]').forEach(el => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: 'clamp(top bottom)',
        end: 'clamp(top top)',
        scrub: true
      }
    });

    const inner = el.querySelector('[data-footer-parallax-inner]');
    const dark = el.querySelector('[data-footer-parallax-dark]');

    if (inner) {
      tl.from(inner, {
        yPercent: -75,
        ease: 'linear'
      });
    }

    if (dark) {
      tl.to(dark, {
        opacity: 0,
        ease: 'linear'
      }, '<');
    }
  });

}
function megamenu() {
  if (document.querySelector('[data-shop-menu-root]')) return;
  const mega_menu_links = document.querySelectorAll("[data-megamenu]");
  const overlay = document.querySelector(".megamenu-overlay");
  if (mega_menu_links.length == 0) return;
  mega_menu_links.forEach(link => {
    const target = document.querySelector("[data-slug='" + link.getAttribute("data-megamenu") + "']")
    link.addEventListener("click", function (e) {
      e.preventDefault()
      link.classList.toggle("megamenu-open")
      target.classList.toggle("show")
    })
  });
  overlay.addEventListener("click", function () {
    document.querySelectorAll(".megamenu").forEach(mega => {
      mega.classList.remove("show")
    });
    mega_menu_links.forEach(link => {
      link.classList.remove("megamenu-open")
    })
  })
}
function initProgressNavigation() {
  // Cache the parent container
  let navProgress = document.querySelector('[data-progress-nav-list]');
  if (!navProgress) return;
  // Get all anchor sections
  let progressAnchors = gsap.utils.toArray('[data-progress-nav-anchor]');
  let anchors = document.querySelectorAll("[data-progress-nav-target]");
  let table_content = document.querySelector(".table-content-wrap");
  let top_padding = window.getComputedStyle(table_content).top;

  top_padding = top_padding.split("px");
  top_padding = top_padding[0];
  if (isMobile()) {
    top_padding = top_padding + 180;
  }
  anchors.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const el = document.querySelector(link.getAttribute("data-progress-nav-target"));

      window.scrollTo({
        top: el.offsetTop - top_padding,
        behavior: 'smooth'
      });
    })
  });
  progressAnchors.forEach((progressAnchor) => {
    let anchorID = progressAnchor.getAttribute('id');
    ScrollTrigger.create({
      trigger: progressAnchor,
      start: '0% 50%',
      end: '100% 50%',
      onEnter: () => {
        let activeLink = navProgress.querySelector('[data-progress-nav-target="#' + anchorID + '"]');
        activeLink.classList.add('is--active');
        // Remove 'is--active' class from sibling links
        let siblings = navProgress.querySelectorAll('[data-progress-nav-target]');
        siblings.forEach((sib) => {
          if (sib !== activeLink) {
            sib.classList.remove('is--active');
          }
        });
      },
      onEnterBack: () => {
        let activeLink = navProgress.querySelector('[data-progress-nav-target="#' + anchorID + '"]');
        activeLink.classList.add('is--active');
        // Remove 'is--active' class from sibling links
        let siblings = navProgress.querySelectorAll('[data-progress-nav-target]');
        siblings.forEach((sib) => {
          if (sib !== activeLink) {
            sib.classList.remove('is--active');
          }
        });
      }
    });
  });
}
function comparison_table_scroll(root = document) {
  const sections = root.matches?.(".comparison-section")
    ? [root]
    : root.querySelectorAll(".comparison-section");

  sections.forEach((section) => {
    const el = section.querySelector("[data-comparison-table-scroll]");
    const scrollbar = section.querySelector("[data-comparison-scrollbar]");
    const thumb = section.querySelector("[data-comparison-scrollbar-thumb]");

    if (!el || !scrollbar || !thumb || el.dataset.comparisonScrollReady === "true") return;
    el.dataset.comparisonScrollReady = "true";

    let maxScroll = 0;
    let maxThumbTravel = 0;
    let thumbWidth = 0;
    let dragOffset = 0;
    let activePointerId = null;
    let updateFrame = null;

    const updateScrollbar = () => {
      updateFrame = null;
      maxScroll = Math.max(el.scrollWidth - el.clientWidth, 0);

      const progress = maxScroll > 0 ? el.scrollLeft / maxScroll : 0;
      section.style.setProperty("--table-scrolled", progress * 20 + "px");

      const trackWidth = scrollbar.clientWidth;
      const visibleRatio = el.scrollWidth > 0 ? Math.min(el.clientWidth / el.scrollWidth, 1) : 1;
      thumbWidth = Math.max(48, trackWidth * visibleRatio);
      maxThumbTravel = Math.max(trackWidth - thumbWidth, 0);

      scrollbar.hidden = maxScroll <= 1;
      thumb.style.width = thumbWidth + "px";
      thumb.style.transform = `translate3d(${progress * maxThumbTravel}px, 0, 0)`;
      scrollbar.setAttribute("aria-valuenow", String(Math.round(progress * 100)));
    };

    const requestScrollbarUpdate = () => {
      if (!updateFrame) updateFrame = requestAnimationFrame(updateScrollbar);
    };

    const setScrollFromPointer = (clientX) => {
      const track = scrollbar.getBoundingClientRect();
      const thumbPosition = Math.max(0, Math.min(clientX - track.left - dragOffset, maxThumbTravel));
      const progress = maxThumbTravel > 0 ? thumbPosition / maxThumbTravel : 0;
      el.scrollLeft = progress * maxScroll;
    };

    scrollbar.addEventListener("pointerdown", (event) => {
      if (maxScroll <= 0 || !event.isPrimary) return;

      event.preventDefault();
      const thumbBounds = thumb.getBoundingClientRect();
      const touchedThumb = event.clientX >= thumbBounds.left && event.clientX <= thumbBounds.right;
      dragOffset = touchedThumb ? event.clientX - thumbBounds.left : thumbWidth / 2;
      activePointerId = event.pointerId;
      scrollbar.setPointerCapture?.(event.pointerId);
      scrollbar.classList.add("is-dragging");
      setScrollFromPointer(event.clientX);
    });

    scrollbar.addEventListener("pointermove", (event) => {
      if (event.pointerId !== activePointerId) return;
      event.preventDefault();
      setScrollFromPointer(event.clientX);
    });

    const releaseScrollbar = (event) => {
      if (event.pointerId !== activePointerId) return;
      activePointerId = null;
      scrollbar.classList.remove("is-dragging");
    };

    scrollbar.addEventListener("pointerup", releaseScrollbar);
    scrollbar.addEventListener("pointercancel", releaseScrollbar);
    scrollbar.addEventListener("keydown", (event) => {
      let nextScroll = el.scrollLeft;

      if (event.key === "ArrowLeft") nextScroll -= 48;
      else if (event.key === "ArrowRight") nextScroll += 48;
      else if (event.key === "Home") nextScroll = 0;
      else if (event.key === "End") nextScroll = maxScroll;
      else return;

      event.preventDefault();
      el.scrollTo({ left: nextScroll, behavior: "smooth" });
    });

    el.addEventListener("scroll", requestScrollbarUpdate, { passive: true });

    if ("ResizeObserver" in window) {
      const resizeObserver = new ResizeObserver(requestScrollbarUpdate);
      resizeObserver.observe(el);
      resizeObserver.observe(scrollbar);
    } else {
      window.addEventListener("resize", requestScrollbarUpdate, { passive: true });
    }

    updateScrollbar();
  });
}


function initStickyFeatures(root) {
  const wraps = Array.from((root || document).querySelectorAll("[data-sticky-feature-wrap]"));
  if (!wraps.length) return;

  wraps.forEach(w => {
    const visualWraps = Array.from(w.querySelectorAll("[data-sticky-feature-visual-wrap]"));
    const items = Array.from(w.querySelectorAll("[data-sticky-feature-item]"));
    const progressBar = w.querySelector("[data-sticky-feature-progress]");

    if (visualWraps.length !== items.length) {
      console.warn("[initStickyFeatures] visualWraps and items count do not match:", {
        visualWraps: visualWraps.length,
        items: items.length,
        wrap: w
      });
    }

    const count = Math.min(visualWraps.length, items.length);
    if (count < 1) return;

    const rm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const DURATION = rm ? 0.01 : 0.75; // If user prefers reduced motion, reduce duration
    const EASE = "power4.inOut";
    const SCROLL_AMOUNT = 0.9; // % of scroll used for step transitions

    const getTexts = el => Array.from(el.querySelectorAll("[data-sticky-feature-text]"));

    if (visualWraps[0]) gsap.set(visualWraps[0], { opacity: 1 });
    gsap.set(items[0], { autoAlpha: 1 });

    let currentIndex = 0;

    // Transition Function
    function transition(fromIndex, toIndex) {
      if (fromIndex === toIndex) return;
      const tl = gsap.timeline({ defaults: { overwrite: "auto" } });

      if (fromIndex < toIndex) {
        tl.to(visualWraps[toIndex], {
          opacity: 1,
          duration: DURATION,
          ease: EASE
        }, 0);
      } else {
        tl.to(visualWraps[fromIndex], {
          opacity: 0,
          duration: DURATION,
          ease: EASE
        }, 0);
      }
      animateOut(items[fromIndex]);
      animateIn(items[toIndex]);
      let total_slides = document.querySelectorAll("[data-sticky-feature-item]").length;
      document.querySelector(".system__count").innerHTML = "0" + (toIndex + 1) + " / 0" + total_slides;
    }

    // Fade out text content items
    function animateOut(itemEl) {
      const texts = getTexts(itemEl);
      gsap.to(texts, {
        autoAlpha: 0,
        y: -30,
        ease: "power4.out",
        duration: 0.4,
        onComplete: () => gsap.set(itemEl, { autoAlpha: 0 })
      });
    }

    // Reveal incoming text content items
    function animateIn(itemEl) {
      const texts = getTexts(itemEl);
      gsap.set(itemEl, { autoAlpha: 1 });
      gsap.fromTo(texts, {
        autoAlpha: 0,
        y: 30
      }, {
        autoAlpha: 1,
        y: 0,
        ease: "power4.out",
        duration: DURATION,
        stagger: 0.1
      });
    }

    const steps = Math.max(1, count - 1);

    ScrollTrigger.create({
      trigger: w,
      start: "top+=15% bottom",
      end: "bottom-=15% top",
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: self => {
        // const p = Math.min(self.progress, SCROLL_AMOUNT) / SCROLL_AMOUNT;
        // let idx = Math.floor(p * steps + 1e-6);
        // idx = Math.max(0, Math.min(steps, idx));
        // progressBar.style.setProperty("--progress", p);
        // // gsap.to(progressBar,{
        // //   scaleX: p,
        // //   ease: "none"
        // // })
        // console.log(idx,currentIndex)
        // if (idx !== currentIndex) {
        //   transition(currentIndex, idx);
        //   currentIndex = idx;
        // }
          const p = self.progress; // 0 → 1 (full scroll)

  const rawIndex = p * count; // divide scroll equally
  let idx = Math.floor(rawIndex);

  idx = Math.max(0, Math.min(count - 1, idx));

  // progress bar (true linear)
  if (progressBar) {
    progressBar.style.setProperty("--progress", p);
  }

  if (idx !== currentIndex) {
    transition(currentIndex, idx);
    currentIndex = idx;
  }
      }
    });
  });
}

function forcePlayAllVideos() {
  const videos = document.querySelectorAll("video");

  videos.forEach(video => {
    // Ensure required attributes
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute("webkit-playsinline", "true");

    const tryPlay = () => {
      video.play().catch(() => {});
    };

    // Try immediately
    tryPlay();

    // Retry after delay (helps iOS)
    setTimeout(tryPlay, 300);

    // Retry when tab becomes active
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        tryPlay();
      }
    });

    // Fallback: first user interaction
    ["touchstart", "click"].forEach(event => {
      document.addEventListener(event, tryPlay, { once: true });
    });
  });
}

function hamburgerMenu(){
  if (document.querySelector('[data-shop-menu-root]')) return;
  const burgerButton = document.querySelector(".burger-btn");
  if (!burgerButton) return;

  burgerButton.addEventListener("click",function(){
    const isMenuOpen = document.body.classList.toggle("mobile-menu-open");
    burgerButton.classList.toggle("is-active", isMenuOpen);
    burgerButton.setAttribute("aria-expanded", isMenuOpen ? "true" : "false");
  })
  document.querySelectorAll(".mobile-menu .menu-header").forEach(function (menuHeader) {
    menuHeader.addEventListener("click", function () {
      const productListMenu = menuHeader.nextElementSibling;
      if (!productListMenu) return;

      const isOpening = !productListMenu.classList.contains("is-open");

      document.querySelectorAll(".mobile-menu .product-list-menu.is-open").forEach(function (openMenu) {
        openMenu.classList.remove("is-open");
      });

      if (isOpening) {
        productListMenu.classList.add("is-open");
      }
    });
  });
}
function customButtonSwiper() {
  const customScrollBtn = document.querySelector(".custom-scroll-btn");
  const area = document.querySelector(".swiper-main-navigtion");

  if (!customScrollBtn || !area) return;

  area.addEventListener("mousemove", function (e) {
    const rect = area.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    customScrollBtn.style.left = (x - 25) + "px";
    customScrollBtn.style.top = (y - 25) + "px";
    customScrollBtn.style.opacity = 1;
  });


}
function articleHtmlSetup(){
  if(!document.querySelector('.article-prose')) return;

  function setpoints(){
    const h2 = document.querySelectorAll('.article-prose h2');
    const table_content = document.querySelector('.table-content');
    table_content.innerHTML = "";
    h2.forEach((item,index) => {
      item.setAttribute('id',"section-"+index);
      item.setAttribute('data-progress-nav-anchor',true);
      let a = document.createElement('a');
      a.href = "#section-"+index;
      a.textContent = item.textContent;
      a.setAttribute('data-progress-nav-target',"#section-"+index);
      table_content.appendChild(a);
    })
  
  }

  setpoints();

  const progressNum = document.getElementById('progressNum');
  const article = document.querySelector('.article-prose');

  function updateProgress() {
    if (!article) return;
    const rect = article.getBoundingClientRect();
    const articleStart = window.scrollY + rect.top;
    const articleEnd = articleStart + article.offsetHeight - window.innerHeight;
    const scrolled = window.scrollY - articleStart;
    let progress = (scrolled / (articleEnd - articleStart)) * 100;
    progress = Math.max(0, Math.min(100, progress));
    if (progressNum) progressNum.textContent = Math.round(progress);
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();
}
function initTestimonials(){
  if(!document.querySelector('.eltior-testi-swiper')) return;
var eltiorTestiSwiper = new Swiper('.eltior-testi-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 500,
    watchOverflow: true,
    grabCursor: true,
    a11y: { enabled: true },
    keyboard: { enabled: true },
    pagination: {
      el: '.eltior-testi-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.eltior-testi-next',
      prevEl: '.eltior-testi-prev',
    },
    breakpoints: {
      640: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
    },
    autoplay: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? false : {
      delay: 5500,
      disableOnInteraction: true,
    },
  });
}
function initProductCategoriesShop(section, swiperEl) {
  var originalSlides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
  var slideCount = originalSlides.length;
  if (!slideCount) return;

  originalSlides.forEach(function (slide, index) {
    slide.dataset.productCategoryIndex = index;
  });

  // Four videos fit on desktop. Repeat small sets so Swiper has enough
  // physical slides to keep its loop continuous at every breakpoint.
  if (slideCount > 1 && slideCount < 9) {
    var copyCount = Math.ceil(9 / slideCount) - 1;
    for (var copy = 0; copy < copyCount; copy += 1) {
      originalSlides.forEach(function (slide) {
        var duplicate = slide.cloneNode(true);
        duplicate.removeAttribute('id');
        duplicate.removeAttribute('data-shopify-editor-block');
        duplicate.dataset.productCategoryLoopCopy = 'true';
        duplicate.querySelectorAll('[id]').forEach(function (element) {
          element.removeAttribute('id');
        });
        duplicate.querySelectorAll('label[for]').forEach(function (label) {
          label.removeAttribute('for');
        });
        swiperEl.querySelector('.swiper-wrapper').appendChild(duplicate);
      });
    }
  }

  var slides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
  var paginationEl = section.querySelector('.product-categories__pagination');
  var controlsEl = section.querySelector('.product-categories__controls');
  var navWrapper = section.querySelector('.testimonial___video-wrapper');
  var nextEl = section.querySelector('.product-categories__nav--next');
  var prevEl = section.querySelector('.product-categories__nav--prev');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var swiperInstance;

  if (controlsEl) controlsEl.hidden = slideCount < 2;
  if (navWrapper) navWrapper.hidden = slideCount < 2;

  function activeSlide() {
    return swiperInstance && swiperInstance.slides[swiperInstance.activeIndex];
  }

  function updateVideoControl(video) {
    var button = video.closest('.product-category').querySelector('[data-product-category-video-toggle]');
    if (!button) return;
    button.classList.toggle('is-paused', video.paused);
    button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
  }

  function syncVideoPlayback() {
    var active = activeSlide();
    slides.forEach(function (slide) {
      var video = slide.querySelector('.product-category__video');
      if (!video) return;
      if (slide === active && video.dataset.userPaused !== 'true' && !reducedMotion.matches) {
        video.muted = true;
        video.playsInline = true;
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () { updateVideoControl(video); });
      } else {
        video.pause();
      }
      updateVideoControl(video);
    });
    if (paginationEl && active) {
      var activeIndex = Number(active.dataset.productCategoryIndex);
      paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach(function (bullet, index) {
        bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
        bullet.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
    }
  }

  if (paginationEl) {
    paginationEl.innerHTML = '';
    for (var index = 0; index < slideCount; index += 1) {
      var bullet = document.createElement('button');
      bullet.type = 'button';
      bullet.className = 'swiper-pagination-bullet';
      bullet.setAttribute('aria-label', 'Go to video ' + (index + 1));
      paginationEl.appendChild(bullet);
    }
  }

  swiperInstance = new Swiper(swiperEl, {
    slidesPerView: 4,
    spaceBetween: 20,
    speed: 500,
    loop: slideCount > 1,
    centeredSlides: true,
    watchSlidesProgress: true,
    grabCursor: slideCount > 1,
    allowTouchMove: slideCount > 1,
    noSwiping: true,
    noSwipingSelector: 'a, button, select, product-form',
    a11y: { enabled: true },
    keyboard: { enabled: false },
    pagination: false,
    navigation: false,
    breakpoints: {
      320: { slidesPerView: 1.15, spaceBetween: 12 },
      640: { slidesPerView: 2.5, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
      1500: { slidesPerView: 4, spaceBetween: 24 },
    },
    on: {
      init: function () { window.requestAnimationFrame(syncVideoPlayback); },
      slideChange: syncVideoPlayback,
      transitionEnd: syncVideoPlayback,
      resize: syncVideoPlayback,
    },
  });

  function moveToProductIndex(index) {
    if (!swiperInstance || swiperInstance.destroyed) return;
    var current = swiperInstance.activeIndex;
    var closest = current;
    var distance = Infinity;
    swiperInstance.slides.forEach(function (slide, slideIndex) {
      if (Number(slide.dataset.productCategoryIndex) !== index) return;
      var candidateDistance = Math.abs(slideIndex - current);
      if (candidateDistance < distance) {
        distance = candidateDistance;
        closest = slideIndex;
      }
    });
    swiperInstance.slideTo(closest);
  }

  function handleClick(event) {
    var openVariants = event.target.closest('[data-product-category-open-variants]');
    if (openVariants && section.contains(openVariants)) {
      event.preventDefault();
      var productSlide = openVariants.closest('.product-category');
      var variantStep = productSlide.querySelector('[data-product-category-variant-step]');
      if (productSlide !== activeSlide()) {
        swiperInstance.slideTo(swiperInstance.slides.indexOf(productSlide));
      }
      if (variantStep) {
        variantStep.hidden = false;
        openVariants.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var closeVariants = event.target.closest('[data-product-category-close-variants]');
    if (closeVariants && section.contains(closeVariants)) {
      var closeSlide = closeVariants.closest('.product-category');
      closeSlide.querySelector('[data-product-category-variant-step]').hidden = true;
      closeSlide.querySelector('[data-product-category-open-variants]').setAttribute('aria-expanded', 'false');
      return;
    }

    var toggle = event.target.closest('[data-product-category-video-toggle]');
    if (toggle && section.contains(toggle)) {
      event.preventDefault();
      var slide = toggle.closest('.product-category');
      var video = slide.querySelector('.product-category__video');
      if (!video) return;
      if (slide !== activeSlide()) {
        video.dataset.userPaused = 'false';
        swiperInstance.slideTo(swiperInstance.slides.indexOf(slide));
      } else if (video.paused) {
        video.dataset.userPaused = 'false';
        video.muted = true;
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () { updateVideoControl(video); });
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
      }
      updateVideoControl(video);
      return;
    }

    var clickedVideo = event.target.closest('.product-category__video');
    if (clickedVideo && section.contains(clickedVideo)) {
      var clickedSlide = clickedVideo.closest('.product-category');
      if (clickedSlide !== activeSlide()) {
        swiperInstance.slideTo(swiperInstance.slides.indexOf(clickedSlide));
      }
      return;
    }

    var bullet = event.target.closest('.swiper-pagination-bullet');
    if (bullet && paginationEl && paginationEl.contains(bullet)) {
      moveToProductIndex(Array.prototype.indexOf.call(paginationEl.children, bullet));
    }
  }

  function handleVariantChange(event) {
    var select = event.target.closest('[data-product-category-variant-select]');
    var swatch = event.target.closest('[data-product-category-flavour]');
    var control = select || swatch;
    if (!control || !section.contains(control)) return;
    var option = select ? select.selectedOptions[0] : swatch;
    if (!option || !option.value) return;
    var card = control.closest('.product-category');
    var compare = card.querySelector('[data-product-category-compare]');
    var discount = card.querySelector('[data-product-category-discount]');
    var confirm = card.querySelector('.product-category__variant-confirm');
    card.querySelector('[data-product-category-variant-input]').value = option.value;
    card.querySelector('[data-product-category-price]').textContent = option.dataset.price;
    compare.textContent = option.dataset.compare;
    discount.textContent = '−' + option.dataset.discount + '%';
    compare.hidden = Number(option.dataset.discount) === 0;
    discount.hidden = compare.hidden;
    if (option.dataset.image) {
      var image = card.querySelector('.product-category__product-image img');
      if (image) {
        image.srcset = '';
        image.src = option.dataset.image;
      }
    }
    if (confirm) {
      confirm.disabled = false;
      confirm.setAttribute('aria-disabled', 'false');
    }
  }

  function handleNext(event) { event.preventDefault(); swiperInstance.slideNext(); }
  function handlePrevious(event) { event.preventDefault(); swiperInstance.slidePrev(); }
  function handleVideoState(event) {
    if (event.target.matches('.product-category__video')) updateVideoControl(event.target);
  }
  function handleMotionChange() { syncVideoPlayback(); }

  section.addEventListener('click', handleClick);
  section.addEventListener('change', handleVariantChange);
  section.addEventListener('play', handleVideoState, true);
  section.addEventListener('pause', handleVideoState, true);
  if (nextEl) nextEl.addEventListener('click', handleNext);
  if (prevEl) prevEl.addEventListener('click', handlePrevious);
  if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', handleMotionChange);

  section.productCategoriesCleanup = function () {
    section.removeEventListener('click', handleClick);
    section.removeEventListener('change', handleVariantChange);
    section.removeEventListener('play', handleVideoState, true);
    section.removeEventListener('pause', handleVideoState, true);
    if (nextEl) nextEl.removeEventListener('click', handleNext);
    if (prevEl) prevEl.removeEventListener('click', handlePrevious);
    if (typeof reducedMotion.removeEventListener === 'function') reducedMotion.removeEventListener('change', handleMotionChange);
    slides.forEach(function (slide) {
      var video = slide.querySelector('.product-category__video');
      if (video) video.pause();
    });
    if (swiperInstance) swiperInstance.destroy(true, true);
    slides.forEach(function (slide) {
      if (slide.dataset.productCategoryLoopCopy === 'true') slide.remove();
    });
  };
}

function initProductCategories(root) {
  var scope = root || document;
  var sections = [];

  if (scope.matches && scope.matches('.product-categories')) sections.push(scope);
  scope.querySelectorAll('.product-categories').forEach(function (section) {
    sections.push(section);
  });

  sections.forEach(function (section) {
    if (section.dataset.productCategoriesReady === 'true') return;

    var swiperEl = section.querySelector('.product-categories__swiper');
    if (!swiperEl) return;

    section.dataset.productCategoriesReady = 'true';

    if (section.classList.contains('product-categories--shop')) {
      initProductCategoriesShop(section, swiperEl);
      return;
    }

    var controlsEl = section.querySelector('.product-categories__controls');
    var navWrapper = section.querySelector('.testimonial___video-wrapper');
    var paginationEl = section.querySelector('.product-categories__pagination');
    var nextEl = section.querySelector('.product-categories__nav--next');
    var prevEl = section.querySelector('.product-categories__nav--prev');
    // Swiper versions that previously used loop mode may leave copied slides
    // in the DOM during a theme-editor refresh. They are visual copies, not
    // additional videos, so remove them before calculating the logical count.
    Array.prototype.slice.call(
      swiperEl.querySelectorAll('.swiper-slide[data-product-category-loop-copy="true"]')
    ).forEach(function (slide) {
      slide.remove();
    });

    var logicalSlides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
    var slideCount = logicalSlides.length;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var swiperInstance = null;
    var manuallySelectedVideo = null;
    var playbackIndex = 0;
    var gestureStartPlaybackIndex = null;
    var gestureFrame = null;
    var videoPointerStart = null;
    var videoPointerHandled = false;
    var lastVideoPointer = null;
    var videoButtonFrame = null;
    var resizeTimer;

    function getVideos() {
      return logicalSlides.map(function (slide) {
        return slide.querySelector('.product-category__video');
      }).filter(Boolean);
    }

    function updateVideoControl(video) {
      var slide = video.closest('.product-category');
      var button = slide && slide.querySelector('[data-product-category-video-toggle]');
      if (!button) return;

      var isPaused = video.paused;
      button.classList.toggle('is-paused', isPaused);
      button.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
    }

    function playVideo(video) {
      /* Re-assert the iOS-safe playback attributes immediately before play().
         Safari can otherwise treat a dynamically controlled video as audible. */
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', 'true');

      if (video.readyState === 0) video.load();

      var playPromise;
      try {
        playPromise = video.play();
      } catch (error) {
        updateVideoControl(video);
        return false;
      }
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          updateVideoControl(video);
        });
      }
      return true;
    }

    function clampPlaybackIndex(index) {
      return Math.max(0, Math.min(slideCount - 1, index));
    }

    function renderPagination() {
      if (!paginationEl) return;

      paginationEl.innerHTML = '';
      for (var index = 0; index < slideCount; index += 1) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        paginationEl.appendChild(bullet);
      }
    }

    function moveCarouselToPlayback(speed) {
      if (!swiperInstance || swiperInstance.destroyed || slideCount < 2) return;

      var minTranslate = swiperInstance.minTranslate();
      var maxTranslate = swiperInstance.maxTranslate();
      var progress = playbackIndex / (slideCount - 1);
      var targetTranslate = minTranslate + ((maxTranslate - minTranslate) * progress);

      swiperInstance.translateTo(
        targetTranslate,
        typeof speed === 'number' ? speed : swiperInstance.params.speed,
        true,
        true
      );
    }

    function updateCarouselControls() {
      var atBeginning = playbackIndex === 0;
      var atEnd = playbackIndex === slideCount - 1;

      if (prevEl) {
        prevEl.disabled = atBeginning;
        prevEl.classList.toggle('swiper-button-disabled', atBeginning);
        prevEl.setAttribute('aria-disabled', atBeginning ? 'true' : 'false');
      }

      if (nextEl) {
        nextEl.disabled = atEnd;
        nextEl.classList.toggle('swiper-button-disabled', atEnd);
        nextEl.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      if (paginationEl) {
        paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach(function (bullet, index) {
          bullet.classList.toggle('swiper-pagination-bullet-active', index === playbackIndex);
          bullet.setAttribute('aria-current', index === playbackIndex ? 'true' : 'false');
        });
      }
    }

    function setPlaybackIndex(index, speed) {
      playbackIndex = clampPlaybackIndex(index);
      manuallySelectedVideo = null;

      moveCarouselToPlayback(speed);

      updateCarouselControls();
      syncVideoPlayback();
    }

    function getPlaybackVideo() {
      var videos = getVideos();
      if (!videos.length) return null;

      if (manuallySelectedVideo) {
        var selectedSlide = manuallySelectedVideo.closest('.swiper-slide');
        if (selectedSlide && selectedSlide.classList.contains('swiper-slide-visible')) {
          return manuallySelectedVideo;
        }
      }

      var playbackSlide = logicalSlides[playbackIndex];
      var playbackVideo = playbackSlide && playbackSlide.querySelector('.product-category__video');
      if (playbackVideo) return playbackVideo;

      if (manuallySelectedVideo && videos.indexOf(manuallySelectedVideo) !== -1) {
        return manuallySelectedVideo;
      }
      return videos[0];
    }

    function syncVideoPlayback(forceVideo) {
      var playbackVideo = getPlaybackVideo();

      getVideos().forEach(function (video) {
        var manuallyPaused = video.dataset.userPaused === 'true';
        var shouldPlay = video === playbackVideo
          && !manuallyPaused
          && (!reducedMotion.matches || forceVideo);

        if (shouldPlay) {
          playVideo(video);
        } else {
          video.pause();
        }
        updateVideoControl(video);
      });
    }

    function getSlidesPerView(width) {
      if (width >= 1500) return 4;
      if (width >= 1024) return 3;
      if (width >= 640) return 2.5;
      return 1;
    }

    function isScrollable(width) {
      return slideCount > getSlidesPerView(width || window.innerWidth);
    }

    function setControlsVisible(visible) {
      if (controlsEl) controlsEl.hidden = !visible;
      if (navWrapper) navWrapper.hidden = !visible;
    }

    function buildSwiper(scrollable) {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      setControlsVisible(scrollable);

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 20,
        speed: 500,
        loop: false,
        centeredSlides: false,
        slideToClickedSlide: false,
        watchOverflow: true,
        watchSlidesProgress: true,
        grabCursor: scrollable,
        allowTouchMove: scrollable,
        a11y: { enabled: true },
        keyboard: { enabled: false },
        pagination: false,
        navigation: false,
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 20 },
          640: { slidesPerView: 2.5, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 },
          1500: { slidesPerView: 4, spaceBetween: 24 },
        },
        on: {
          init: function () {
            window.requestAnimationFrame(syncVideoPlayback);
          },
          slideChange: function () {
            // Playback is intentionally controlled separately. Near the end,
            // Swiper cannot position every remaining card as its layout-active
            // slide, but those visible edge cards must still play sequentially.
            syncVideoPlayback();
          },
          touchStart: function () {
            gestureStartPlaybackIndex = playbackIndex;
            videoPointerHandled = false;
            if (gestureFrame !== null) {
              window.cancelAnimationFrame(gestureFrame);
              gestureFrame = null;
            }
          },
          touchEnd: function (swiper) {
            if (videoPointerHandled) {
              videoPointerHandled = false;
              gestureStartPlaybackIndex = null;
              return;
            }

            var startIndex = gestureStartPlaybackIndex;
            var direction = swiper.swipeDirection;

            gestureFrame = window.requestAnimationFrame(function () {
              gestureFrame = null;
              gestureStartPlaybackIndex = null;

              if (direction === 'next') {
                setPlaybackIndex(startIndex + 1);
              } else if (direction === 'prev') {
                setPlaybackIndex(startIndex - 1);
              } else {
                setPlaybackIndex(startIndex);
              }
            });
          },
          transitionEnd: syncVideoPlayback,
          resize: syncVideoPlayback,
        },
      });

      renderPagination();
      setPlaybackIndex(playbackIndex, 0);
    }

    var lastScrollable = null;

    function syncCarouselMode() {
      var scrollable = isScrollable();
      if (scrollable === lastScrollable && swiperInstance) {
        setControlsVisible(scrollable);
        swiperInstance.update();
        moveCarouselToPlayback(0);
        syncVideoPlayback();
        return;
      }
      lastScrollable = scrollable;
      buildSwiper(scrollable);
    }

    function toggleVideoFromButton(button, event, deferMovement) {
      event.preventDefault();
      if (!deferMovement) event.stopPropagation();

      var slide = button.closest('.product-category');
      var video = slide && slide.querySelector('.product-category__video');
      if (!video) return;

      if (video.paused) {
        var selectedIndex = logicalSlides.indexOf(slide);
        video.dataset.userPaused = 'false';
        /* Keep play() inside the user-activation event. This is required by
           iPhone Safari and Chrome iOS when autoplay was previously paused. */
        playVideo(video);
        if (selectedIndex !== -1) {
          if (deferMovement) {
            playbackIndex = clampPlaybackIndex(selectedIndex);
            manuallySelectedVideo = null;
            updateCarouselControls();
            syncVideoPlayback(true);

            if (videoButtonFrame !== null) window.cancelAnimationFrame(videoButtonFrame);
            videoButtonFrame = window.requestAnimationFrame(function () {
              videoButtonFrame = null;
              moveCarouselToPlayback();
            });
          } else {
            setPlaybackIndex(selectedIndex);
            syncVideoPlayback(true);
          }
        } else {
          manuallySelectedVideo = video;
          syncVideoPlayback(true);
        }
      } else {
        video.dataset.userPaused = 'true';
        manuallySelectedVideo = video;
        video.pause();
        syncVideoPlayback();
      }
      updateVideoControl(video);
    }

    function handleVideoPointerDown(event) {
      var button = event.target.closest('[data-product-category-video-toggle]');
      if (!button || !section.contains(button) || (event.button !== undefined && event.button !== 0)) return;

      videoPointerStart = {
        button: button,
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
      };
    }

    function handleVideoPointerUp(event) {
      if (!videoPointerStart || videoPointerStart.pointerId !== event.pointerId) return;

      var pointerStart = videoPointerStart;
      videoPointerStart = null;
      var distanceX = Math.abs(event.clientX - pointerStart.x);
      var distanceY = Math.abs(event.clientY - pointerStart.y);

      if (distanceX > 10 || distanceY > 10) return;
      videoPointerHandled = true;
      lastVideoPointer = {
        button: pointerStart.button,
        time: Date.now(),
      };
      toggleVideoFromButton(pointerStart.button, event, true);
    }

    function handleVideoClick(event) {
      var button = event.target.closest('[data-product-category-video-toggle]');
      if (!button || !section.contains(button)) return;

      /* pointerup already handled this tap; use click as a Safari fallback when
         pointer events are not delivered, without toggling the video twice. */
      if (lastVideoPointer && lastVideoPointer.button === button && Date.now() - lastVideoPointer.time < 700) {
        lastVideoPointer = null;
        return;
      }

      toggleVideoFromButton(button, event, false);
    }

    function handleVideoKeydown(event) {
      var button = event.target.closest('[data-product-category-video-toggle]');
      if (!button || !section.contains(button)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      toggleVideoFromButton(button, event);
    }

    function handlePrevious(event) {
      event.preventDefault();
      if (playbackIndex > 0) setPlaybackIndex(playbackIndex - 1);
    }

    function handleNext(event) {
      event.preventDefault();
      if (playbackIndex < slideCount - 1) setPlaybackIndex(playbackIndex + 1);
    }

    function handlePaginationClick(event) {
      var bullet = event.target.closest('.swiper-pagination-bullet');
      if (!bullet || !paginationEl || !paginationEl.contains(bullet)) return;

      var bulletIndex = Array.prototype.indexOf.call(
        paginationEl.querySelectorAll('.swiper-pagination-bullet'),
        bullet
      );
      if (bulletIndex === -1) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setPlaybackIndex(bulletIndex);
    }

    function handleCarouselKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        if (playbackIndex > 0) setPlaybackIndex(playbackIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        if (playbackIndex < slideCount - 1) setPlaybackIndex(playbackIndex + 1);
      }
    }

    function handleVideoState(event) {
      if (event.target.matches('.product-category__video')) updateVideoControl(event.target);
    }

    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncCarouselMode, 150);
    }

    section.addEventListener('pointerdown', handleVideoPointerDown, true);
    section.addEventListener('pointerup', handleVideoPointerUp, true);
    section.addEventListener('click', handleVideoClick, true);
    section.addEventListener('keydown', handleVideoKeydown, true);
    if (prevEl) prevEl.addEventListener('click', handlePrevious);
    if (nextEl) nextEl.addEventListener('click', handleNext);
    if (paginationEl) paginationEl.addEventListener('click', handlePaginationClick);
    swiperEl.addEventListener('keydown', handleCarouselKeydown);
    section.addEventListener('play', handleVideoState, true);
    section.addEventListener('pause', handleVideoState, true);
    window.addEventListener('resize', handleResize);

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', syncVideoPlayback);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(syncVideoPlayback);
    }

    getVideos().forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.dataset.userPaused = 'false';
      video.pause();
      updateVideoControl(video);
    });

    syncCarouselMode();

    section.productCategoriesCleanup = function () {
      clearTimeout(resizeTimer);
      if (gestureFrame !== null) window.cancelAnimationFrame(gestureFrame);
      if (videoButtonFrame !== null) window.cancelAnimationFrame(videoButtonFrame);
      section.removeEventListener('pointerdown', handleVideoPointerDown, true);
      section.removeEventListener('pointerup', handleVideoPointerUp, true);
      section.removeEventListener('click', handleVideoClick, true);
      section.removeEventListener('keydown', handleVideoKeydown, true);
      section.removeEventListener('play', handleVideoState, true);
      section.removeEventListener('pause', handleVideoState, true);
      window.removeEventListener('resize', handleResize);
      if (prevEl) prevEl.removeEventListener('click', handlePrevious);
      if (nextEl) nextEl.removeEventListener('click', handleNext);
      if (paginationEl) paginationEl.removeEventListener('click', handlePaginationClick);
      swiperEl.removeEventListener('keydown', handleCarouselKeydown);
      if (typeof reducedMotion.removeEventListener === 'function') {
        reducedMotion.removeEventListener('change', syncVideoPlayback);
      } else if (typeof reducedMotion.removeListener === 'function') {
        reducedMotion.removeListener(syncVideoPlayback);
      }
      getVideos().forEach(function (video) {
        video.pause();
      });
      if (swiperInstance) swiperInstance.destroy(true, true);
    };
  });
}
function loadImagesInView() {
  const images = document.querySelectorAll('[datasrc]');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const image = entry.target;

        image.src = image.getAttribute('datasrc');
        image.removeAttribute('datasrc');
        image.srcset = '';



        observer.unobserve(image);
      }
    });
  }, {
    rootMargin: '100px' // start loading 100px before it enters viewport
  });

  images.forEach(image => observer.observe(image));
}
document.addEventListener("DOMContentLoaded", function () {
  const dvh = window.innerHeight;
  document.body.classList.add("is-loaded");
  document.documentElement.style.setProperty('--full-dvh', dvh + 'px');
  noticeSlider();
  articleHtmlSetup();
  // userResultsSlider();
  productsSlider();
  ingradientSlider();
  accordion()
  initProductHowToUseVideos();
  initProductCardHoverVideos();
  initRoutineBundleAccordions();
  playPauseVideos();
  videoPopup();
  productSwiperMain();
  cart();
  // upsellSwiper();
  backToTop();
  provenByDesign();
  // provenSlider();
  initCascadingSlider();

  splitText();
  setDelays()
  // siteBy();
  // initFooterParallax();
  heroSectionAnimation();
  headerHideShow();
  initProgressNavigation();
  megamenu();
  initLenis();
  comparison_table_scroll();
  initStickyFeatures();
  hamburgerMenu();
  customButtonSwiper();
  initTestimonials();
  // forcePlayAllVideos();
  initProductCategories();
  loadImagesInView();
})

document.addEventListener("shopify:section:load", function (event) {
  comparison_table_scroll(event.target);
  initProductHowToUseVideos(event.target);
  initProductCardHoverVideos(event.target);
  initRoutineBundleAccordions(event.target);
  initProductCategories(event.target);
});

document.addEventListener("product-info:loaded", function (event) {
  initProductHowToUseVideos(event.target);
});

document.addEventListener("shopify:section:unload", function (event) {
  var productCategoriesSection = event.target.querySelector('.product-categories');
  if (productCategoriesSection && typeof productCategoriesSection.productCategoriesCleanup === 'function') {
    productCategoriesSection.productCategoriesCleanup();
  }
});
